import { getPublicSettings } from './appSettings';

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('FileReader failed'));
    reader.readAsDataURL(blob);
  });
}

/** Engagement logo, then the LCTF PDF mark used on proposal downloads. */
export async function loadLctfPdfLogoBase64(): Promise<string | undefined> {
  try {
    const settings = await getPublicSettings();
    if (settings.engagementLogo?.url) {
      const logoUrl = settings.engagementLogo.url.includes('?')
        ? `${settings.engagementLogo.url}&t=${Date.now()}`
        : `${settings.engagementLogo.url}?t=${Date.now()}`;
      const response = await fetch(logoUrl, { mode: 'cors', cache: 'no-store', credentials: 'omit' });
      if (response.ok) return blobToDataUrl(await response.blob());
    }
  } catch {
    /* fall through */
  }
  try {
    const fallbackResponse = await fetch('/assets/logo/LC_pdf_logo.png');
    if (fallbackResponse.ok) return blobToDataUrl(await fallbackResponse.blob());
  } catch {
    /* ignore */
  }
  return undefined;
}

/**
 * White lockup (wordmark plus the oval mark) for a dark header.
 * The company name is in the artwork, so callers should not set it again in type.
 */
export async function loadLctfLockupLogoBase64(): Promise<string | undefined> {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/assets/logo/LC_pdf_logo.png`);
    if (response.ok) return blobToDataUrl(await response.blob());
  } catch {
    /* ignore */
  }
  return undefined;
}

/**
 * The small round TLCF mark (green on cream). Use on white letterheads that
 * need to print cleanly — the engagement/PDF logos above are white-on-transparent
 * and only read on a dark band.
 */
export async function loadLctfProfileMarkBase64(): Promise<string | undefined> {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/assets/logo/LCTF%20Profile.png`);
    if (response.ok) return blobToDataUrl(await response.blob());
  } catch {
    /* ignore */
  }
  return undefined;
}
